// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__36gg8","top":"styles_top__WdxYc"};